import axios from 'axios';

const list = () => axios({
    method: 'get',
    url: `${ process.env.VUE_APP_API_URL }/PPPElements/`,
    withCredentials: true,
});

const item = (id) => axios({
    method: 'get',
    url: `${ process.env.VUE_APP_API_URL }/PPPElements/Details/${ id }`,
    withCredentials: true,
});

const create = (element) => {
    const { icon, image, ...json } = element;

    const data = new FormData();
    data.set('data', JSON.stringify(json));
    data.append('icon', icon);
    data.append('image', image);

    return axios({
        method: 'post',
        url: `${ process.env.VUE_APP_API_URL }/PPPElements/Create`,
        withCredentials: true,
        data,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const update = (id, element) => {
    const { icon, image, ...json } = element;

    const data = new FormData();
    data.set('data', JSON.stringify(json));
    if (typeof icon !== 'undefined' && icon) {
        data.append('icon', icon);
    }
    if (typeof image !== 'undefined' && image) {
        data.append('image', image);
    }

    return axios({
        method: 'post',
        url: `${ process.env.VUE_APP_API_URL }/PPPElements/Update/${ id }`,
        withCredentials: true,
        data,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const remove = (id) => axios({
    method: 'delete',
    url: `${ process.env.VUE_APP_API_URL }/PPPElements/Delete/${ id }`,
    withCredentials: true,
});

export default {
    list,
    item,
    create,
    update,
    remove,
};
